import { AxiosError, AxiosResponse } from 'axios'

export const getResponseData = (response: AxiosResponse) => {
  return response.data.data
}

export const getResponseMessage = (response: AxiosResponse | any): string => {
  return response.data.data.server_response
}

export const getErrorMessage = (response: AxiosError | any) => {
  if (response && response.response && response.response.data) {
    return response.response?.data?.data?.server_response
  }

  return response.response?.data?.data?.server_response
}

export const getErrorHelper = (response: AxiosError | any) => {
  try {
    const errors = response?.response?.data?.errors

    if (!errors) {
      if (response && response.response) {
        return response?.response?.data.message
      }
      return response.message || 'Unsuccessful. Try again'
    }
    const keys = Object.keys(errors)
    const errStr = errors[keys[0]][0]
    return errStr
  } catch (error) {
    return 'Unsuccessful. Try again.'
  }
}

export const getValidationErrorMessage = (response: AxiosError | any) => {
  try {
    console.log(response)
    const errors = response?.data?.errors

    if (!errors) {
      if (response && response.data) {
        return response?.data.message
      }
      return response.message || 'Unsuccessful. Try again'
    }
    const keys = Object.keys(errors)
    const errStr = errors[keys[0]][0]
    return errStr
  } catch (error) {
    return 'Unsuccessful. Try again.'
  }
}
